var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMediaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 71,
    height: 70.673,
    viewBox: "0 0 71 70.673",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1627",
    "data-name": "Rectangle 1627",
    width: 71,
    height: 70.673,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "media-icon",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3816",
    "data-name": "Group 3816",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60312",
    "data-name": "Path 60312",
    d: "M71,63.618c-.088.33-.179.658-.261.988a7.738,7.738,0,0,1-7.3,6.03c-2.1.073-4.209.015-6.315.012a2.691,2.691,0,0,1-.345-.061V57.07H55.747q-23.893,0-47.793,0A7.744,7.744,0,0,1,.218,50.973a9.122,9.122,0,0,1-.209-1.991Q0,28.553,0,8.126A7.669,7.669,0,0,1,6.587.184,47.664,47.664,0,0,1,12.405.072c.479-.006.406.339.406.63q0,2.5,0,4.994v5.287h.954q17.689,0,35.379.012a2.075,2.075,0,0,0,1.433-.527Q56.03,5.9,61.5,1.369a5.571,5.571,0,0,1,9.105,2.939,5.378,5.378,0,0,1-1.818,5.56c-.812.715-1.657,1.394-2.551,2.139.215.155.37.276.53.382a8.816,8.816,0,0,1,4.084,6.381,2.714,2.714,0,0,0,.148.451ZM12.793,43.486c-.33,0-.582,0-.83,0-1.433,0-2.869-.03-4.3.012A5.793,5.793,0,0,0,4.9,54.312a6.653,6.653,0,0,0,3.469.77q27.189-.014,54.374-.009a8.05,8.05,0,0,1,5.86,2.236,2.1,2.1,0,0,0,.312.2c.018-.236.039-.394.039-.551,0-12.39.021-24.783-.021-37.173a6.687,6.687,0,0,0-3.706-6.009,1,1,0,0,0-1.336.145q-7.158,5.986-14.353,11.917a3.076,3.076,0,0,1-1.145.588c-3.582.973-7.172,1.918-10.763,2.869-.439.115-.882.209-1.391.33a3.169,3.169,0,0,1,.133-.4q2.691-5.622,5.393-11.238a2.024,2.024,0,0,1,.524-.624Q44.6,15.419,46.929,13.5a3.075,3.075,0,0,1,.533-.282l-.185-.2H12.793Zm-1.976-1.96V2.941c0-.139-.012-.279,0-.415.039-.394-.145-.53-.524-.521-.718.015-1.433.012-2.151,0a5.972,5.972,0,0,0-6.16,6.133c.076,11.669.03,23.34.033,35.009,0,.239.021.479.033.745.7-.494,1.312-.985,1.979-1.379a7.959,7.959,0,0,1,4.4-.994c.779.021,1.557,0,2.394,0M48.75,23.936c4.69-3.894,9.369-7.781,14.081-11.69L58.21,6.683l-14.1,11.741c1.5,1.812,2.924,3.536,4.354,5.26a2.654,2.654,0,0,0,.288.251M58.8,68.644c1.585,0,3.085.018,4.584-.006a5.794,5.794,0,0,0,5.557-5.206,5.648,5.648,0,0,0-4.636-6.2,44.982,44.982,0,0,0-5.39-.121c-.036,0-.07.055-.115.094Zm5.56-57.662c1.154-.964,2.248-1.818,3.272-2.751A3.548,3.548,0,0,0,68.055,3.4a3.525,3.525,0,0,0-4.769-.858c-1.227.851-2.339,1.867-3.56,2.857,1.56,1.882,3.072,3.7,4.636,5.584M46.808,24.8c-1.33-1.6-2.569-3.1-3.869-4.666-.318.654-.609,1.157-.8,1.694a.971.971,0,0,0,.082.782c.612.839,1.267,1.651,1.942,2.439a.886.886,0,0,0,.688.27c.609-.106,1.2-.309,1.96-.518m-7,1.857c.942-.251,1.676-.448,2.524-.673l-1.382-1.73c-.4.839-.73,1.536-1.142,2.4",
    transform: "translate(0 0.003)",
    fill: "#051631"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60313",
    "data-name": "Path 60313",
    d: "M5.6,7.888V6.034c.261-.015.524-.048.791-.048,4.554,0,9.105.012,13.659-.015.685-.006.906.212.833.861a8.118,8.118,0,0,0-.012,1.057Z",
    transform: "translate(11.362 12.121)",
    fill: "#051631"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60314",
    "data-name": "Path 60314",
    d: "M5.595,9.291V7.452c.285-.018.551-.048.821-.048,4.53,0,9.06.012,13.593-.018.706-.006.976.185.876.891a7.463,7.463,0,0,0-.009,1.015Z",
    transform: "translate(11.358 14.993)",
    fill: "#051631"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60315",
    "data-name": "Path 60315",
    d: "M20.869,10.724H5.6V8.857c.321-.018.615-.052.906-.052q6.681,0,13.362,0c1,0,1,0,1,1.021v.9",
    transform: "translate(11.364 17.872)",
    fill: "#051631"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60316",
    "data-name": "Path 60316",
    d: "M5.636,10.623H29.664V30.467H5.636Zm22.022,12.05V12.611c-.218-.018-.421-.052-.624-.052q-9.395,0-18.792-.012c-.521,0-.724.133-.721.7.021,4.394.009,8.784.015,13.175a4.9,4.9,0,0,0,.058.558c.082.045.164.094.248.139,2.669-2.806,5.342-5.615,8.069-8.478,1.594,1.757,3,3.309,4.46,4.915,1.3-1.2,2.563-2.363,3.827-3.53,1.17.894,2.26,1.73,3.46,2.648m-11.69-1.021Q12.6,25.188,9.4,28.534H22.2l-6.23-6.881m5.739,3.382c1.051,1.161,2.033,2.257,3.033,3.339a.756.756,0,0,0,.485.2c.667.024,1.336,0,2,.015.355.006.491-.142.485-.5-.012-.851.012-1.706-.015-2.557a.78.78,0,0,0-.261-.515c-.918-.733-1.848-1.451-2.8-2.142a.615.615,0,0,0-.576-.006c-.779.679-1.527,1.394-2.354,2.16",
    transform: "translate(11.441 21.567)",
    fill: "#ec431f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60317",
    "data-name": "Path 60317",
    d: "M12.248,12.458v1.954H10.333c0-.536-.027-1.057.015-1.573a.539.539,0,0,1,.367-.364c.5-.045,1-.018,1.533-.018",
    transform: "translate(20.958 25.276)",
    fill: "#ec431f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60318",
    "data-name": "Path 60318",
    d: "M34.652,30.468H14.72V10.627H34.652ZM16.671,12.6v.673c0,4.851.012,9.7-.015,14.553,0,.618.179.779.782.776q7.24-.036,14.484,0c.609,0,.782-.17.779-.782-.024-4.851-.015-9.7-.015-14.553,0-.2-.018-.409-.03-.667Z",
    transform: "translate(29.882 21.575)",
    fill: "#ec431f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60319",
    "data-name": "Path 60319",
    d: "M27.261,18.08c-3.536,1.93-6.966,3.806-10.481,5.727V11.935c3.509,2.057,6.948,4.072,10.481,6.145m-8.466-2.666v5.03c1.494-.815,2.891-1.582,4.436-2.427-1.539-.9-2.936-1.721-4.436-2.6",
    transform: "translate(34.064 24.23)",
    fill: "#ec431f"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaIcon);
export default __webpack_public_path__ + "static/media/media-icon.f8d9b667c138da0307af4b17f6bcf177.svg";
export { ForwardRef as ReactComponent };